import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { LinkContainer } from 'react-router-bootstrap';
import { ButtonGroup, Button } from 'react-bootstrap';

import LoadingSpinner from '../../../components/shared/Loading';

import * as utils from './../../../utils';

import { v4 } from 'uuid';
import { impersonateBrokerId } from './../../../person/actions';
import { saveSubmission } from './../../../submissions/api';
import { submissionCreateSuccess, submissionEditSuccess, setIsExcessOnly, changeSubmission } from './../../../submissions/actions';
import { fetchBrokerages } from './../../../brokerages/actions';
import * as ratingsActions from 'app/ratings/actions';
import { CHANGE_SUBMISSION } from '../../../constants/submission';
import { getItemsNeededToDesignatedContractors } from '../../../submissions/components/GCList';
import { getU658DesignatedContractorsName } from '../../../submissions/components/DesignatedGeneralContractor';
import { isU653Applicable } from '../../../submissions/components/OptionalFormsSelector';
import { QUOTE_STATUS_BOUND_MANUAL } from '../../../submissions/components/ChangeQuoteStatusModal';
import { DEFAULT_OPTIONAL_COVERAGES } from '../../../submissions/components/OptionalCoverageSelector';
import { updateSubjectivities } from '../../../submissions/components/getSubjectivities';

const DEFAULT_ADDITIONAL_COVERAGES_OI = ['terror'];
const DEFAULT_ADDITIONAL_COVERAGES_OCP = ['terror'];

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { submission, user, quoteCount, person } = this.props;
        const { defaultPreference } = user || {};
        const { type } = submission;
        this.props.dispatch(fetchBrokerages(user, submission));
        let isNewSubmission = false;
        try {
            if (defaultPreference) {
            if (submission.type === 'oi' && defaultPreference[submission.type].additional_coverages) {
                const identityRecoveryIndex = defaultPreference[submission.type].additional_coverages.findIndex(add => add === 'identityRecovery');
                if (identityRecoveryIndex > -1) {
                    defaultPreference[submission.type].additional_coverages.splice(identityRecoveryIndex, 1);
                }
            }
        }
        } catch (err) {
            console.log(err);
        }

        if (!submission.id) {
            isNewSubmission = true; // new submission has no id yet
            submission.id = v4();
        }

        if (
            (isNewSubmission && quoteCount === 0) ||
            quoteCount > 0 ||
            (!!this.props.app.submission && Object.keys(this.props.app.submission).length > 0)
        ) {
            submission.coverages = utils.submission.setDefaultCoverage(
                submission,
                defaultPreference,
                submission.type === 'oi' ? DEFAULT_ADDITIONAL_COVERAGES_OI : DEFAULT_ADDITIONAL_COVERAGES_OCP,
                DEFAULT_OPTIONAL_COVERAGES,
                isNewSubmission,
                type
            );

            const subjectivitiesDescription = updateSubjectivities(submission, true)
            submission.ratings[submission.type].subjectivitiesDescription = subjectivitiesDescription
            submission.ratings.options.subjectivitiesDescription = subjectivitiesDescription

            if (submission.isWildFireExcluded !== undefined) {
               delete submission['isWildFireExcluded'];
            }

            if (submission.coverages.gl &&
                submission.coverages.gl.optional &&
                submission.coverages.gl.optional.isWildFireExcluded) {
                delete submission.coverages.gl.optional['isWildFireExcluded'];
            }

            if (isNewSubmission) {
                submission.commission = utils.submission.setCommission(user);
            }
            if (person.isUnderwriter && submission.brokerId) {
                this.props.dispatch(impersonateBrokerId(submission.brokerId));
                person.brokerId = submission.brokerId
            }
            // Set manuallySetPricing to false if logged in user is broker
            const manuallySetPricing = person.isUnderwriter && submission.manuallySetPricing === 'true'
            submission.manuallySetPricing = manuallySetPricing.toString()

            const designatedContractors = getItemsNeededToDesignatedContractors(
                submission.ratings[submission.type],
                submission.coverages.gl && submission.coverages.gl.base ?
                    submission.coverages.gl.base : '',
                submission.type,
                submission,
                submission.coverages.gl && submission.coverages.gl.additional ?
                    submission.coverages.gl.additional : {},
                submission.excessLimitAmount
            );
            if ((Array.isArray(designatedContractors) &&
                (designatedContractors.length > 0) ||
                Object.hasOwn(submission.ratings[submission.type], 'designatedContractors'))
            ) {
                Object.assign(
                    submission.ratings[submission.type],
                    { designatedContractors }
                );
            }
            if ((Array.isArray(designatedContractors) &&
                (designatedContractors.length > 0) ||
                Object.hasOwn(submission.ratings.options, 'designatedContractors'))
            ) {
                Object.assign(
                    submission.ratings.options,
                    { designatedContractors }
                );
            }
            const u658ContractorName = getU658DesignatedContractorsName(
                    submission.ratings[submission.type],
                    submission.coverages.gl && submission.coverages.gl.base ?
                        submission.coverages.gl.base : '',
                    submission.type
            );
            if (
                typeof u658ContractorName === 'string' &&
                (u658ContractorName.length > 0 || Object.hasOwn(submission.ratings[submission.type], 'u658ContractorName'))
            ) {
                Object.assign(
                    submission.ratings[submission.type],
                    { u658ContractorName }
                );
            }
            if (
                typeof u658ContractorName === 'string' &&
                (u658ContractorName.length > 0 || Object.hasOwn(submission.ratings.options, 'u658ContractorName'))
            ) {
                Object.assign(
                    submission.ratings.options,
                    { u658ContractorName }
                );
            }

            if (
                !isU653Applicable(
                    submission.coverages.gl && submission.coverages.gl.base ? submission.coverages.gl.base : '',
                    submission.type)
            ) {
                if (Object.hasOwn(submission.ratings[submission.type], 'u653Deductible')) {
                    delete submission.ratings[submission.type]['u653Deductible'];
                }
                if (Object.hasOwn(submission.ratings.options, 'u653Deductible')) {
                    delete submission.ratings.options['u653Deductible'];
                }
                if (Object.hasOwn(submission, 'optionalForms') && Object.hasOwn(submission.optionalForms, 'u653')) {
                    delete submission.optionalForms['u653'];
                }
            } else if (submission.manuallySetPricing === 'false') {
                let deductible;
                if (!Number.isNaN(submission.totalCost)) {
                    if (Number(submission.totalCost) <= 25000000) {
                        deductible = 25000;
                    } else if (Number(submission.totalCost) > 25000000) {
                        deductible = 50000;
                    }
                    Object.assign(submission.ratings.options, {u653Deductible: deductible});
                    Object.assign(submission.ratings[submission.type], {u653Deductible: deductible});

                    submission.optionalForms = {
                        ...submission.optionalForms,
                        u653: {
                            isSelected: true
                        }
                    }
                }
            }

            // remove CG2165 optional form for System Generated.
            if (
                Object.hasOwn(submission, 'optionalForms') &&
                Object.hasOwn(submission.optionalForms, 'CG2165') &&
                submission.manuallySetPricing === "false"
            ) {
                delete submission.optionalForms['CG2165']
            }

            if (Object.hasOwn(submission, 'optionalForms') && Object.keys(submission.optionalForms).length === 0) {
                delete submission['optionalForms'];
            }

            if (submission.manuallySetPricing === 'false' || submission.isExcessOnly === true) {
                // helps to remove transaction status for DRAFT(quote that haven't done argopi preview flow)
                if ((submission.status === 'DRAFT' || (submission.status === 'REFERRAL' && submission.quoteDrafted === 'true')) && submission.hasOwnProperty('transactionStatus')) {
                    delete submission.transactionStatus;
                }
            }

            // remove scheduleFactor and manualRate for system generated pricing
            if (submission.manuallySetPricing === 'false') {
                if (Object.hasOwn(submission.ratings[submission.type], 'scheduleFactor')) {
                    delete submission.ratings[submission.type].scheduleFactor;
                }
                if (Object.hasOwn(submission.ratings.options, 'scheduleFactor')) {
                    delete submission.ratings.options.scheduleFactor;
                }
                if (Object.hasOwn(submission.ratings[submission.type], 'manualRate')) {
                    delete submission.ratings[submission.type].manualRate;
                }
                if (Object.hasOwn(submission.ratings.options, 'manualRate')) {
                    delete submission.ratings.options.manualRate;
                }
            }

            saveSubmission(submission, user, person)
                .then(resp => {
                    const actionData = {
                        submission: resp.data ? resp.data : resp,
                        payload: submission,
                        quoteCount: this.props.quoteCount,
                        result: resp.result
                    };

                    if (isNewSubmission) {
                        this.props.dispatch(submissionCreateSuccess(actionData));
                    } else if (
                        !(submission.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL
                        && submission.quoteDrafted === 'true') && (resp && resp.ignoreSaveAndReportGen !== true)
                    ) {
                        this.props.dispatch(submissionEditSuccess(actionData));
                    }
                    if (resp.hasOwnProperty('data') && resp.data.hasOwnProperty('policyId')) {
                        const updatedSubmission = submission;
                        Object.assign(updatedSubmission, {policyId: resp.data.policyId}, {transactionId: resp.data.transactionId})
                        this.props.dispatch(changeSubmission(updatedSubmission));
                    }
                    if (resp.hasOwnProperty('data') && resp.data.hasOwnProperty('updatedAt')) {
                        this.props.handleApiCall(resp.data.updatedAt);
                    }

                    if (resp.hasOwnProperty('data') && resp.data.hasOwnProperty('ratings')) {
                        this.props.dispatch(ratingsActions.update(resp.data.ratings));
                    }
                    if (resp.hasOwnProperty('referredSubmission') && resp.result === 'submission_failed_referral_rules_validation' && resp.referredSubmission.hasOwnProperty('ratings')) {
                        this.props.dispatch(ratingsActions.update(resp.referredSubmission.ratings));
                        if (resp.referredSubmission.hasOwnProperty('policyId') && resp.referredSubmission.hasOwnProperty('transactionId')) {
                            const updatedSubmission = submission
                            Object.assign(updatedSubmission, {policyId: resp.referredSubmission.policyId}, {transactionId: resp.referredSubmission.transactionId})
                            this.props.dispatch(changeSubmission(updatedSubmission));
                        }
                    } else if (resp.hasOwnProperty('pendingSubmission') && resp.result === 'submission_failed_clearance' && resp.pendingSubmission.hasOwnProperty('ratings')) {
                        this.props.dispatch(ratingsActions.update(resp.pendingSubmission.ratings));
                        if (resp.pendingSubmission.hasOwnProperty('policyId') && resp.pendingSubmission.hasOwnProperty('transactionId')) {
                            const updatedSubmission = submission
                            Object.assign(updatedSubmission, {policyId: resp.pendingSubmission.policyId}, {transactionId: resp.pendingSubmission.transactionId})
                            this.props.dispatch(changeSubmission(updatedSubmission));
                        }
                    }
                    if (submission.isExcessOnly === true) {
                        this.props.dispatch(setIsExcessOnly(false));
                    }

                    this.props.handleSubmit(null, resp);
                })
                .catch(err => {
                    console.log('Error', err);
                    this.props.handleSubmit(err, null);
                });
        } else {
            // Skip save saveSubmission submission api call
            submission.coverages = utils.submission.setDefaultCoverage(
                submission,
                defaultPreference,
                submission.type === 'oi' ? DEFAULT_ADDITIONAL_COVERAGES_OI : DEFAULT_ADDITIONAL_COVERAGES_OCP,
                DEFAULT_OPTIONAL_COVERAGES,
                isNewSubmission,
                type
            );

            const designatedGC = getItemsNeededToDesignatedContractors(
                submission.ratings[submission.type],
                submission.coverages.gl && submission.coverages.gl.base ?
                    submission.coverages.gl.base : '',
                submission.type,
                submission,
                submission.coverages.gl && submission.coverages.gl.additional ?
                    submission.coverages.gl.additional : {},
                submission.excessLimitAmount
            );
            if ((Array.isArray(designatedGC) &&
                (designatedGC.length > 0) ||
                Object.hasOwn(submission.ratings[submission.type], 'designatedContractors'))
            ) {
                Object.assign(
                    submission.ratings[submission.type],
                    { designatedContractors: designatedGC }
                );
            }
            if ((Array.isArray(designatedGC) &&
                (designatedGC.length > 0) ||
                Object.hasOwn(submission.ratings.options, 'designatedContractors'))
            ) {
                Object.assign(
                    submission.ratings.options,
                    { designatedContractors: designatedGC }
                );
            }
            const u658GCName = getU658DesignatedContractorsName(
                    submission.ratings[submission.type],
                    submission.coverages.gl && submission.coverages.gl.base ?
                        submission.coverages.gl.base : '',
                    submission.type
            );
            if (
                typeof u658GCName === 'string' &&
                (u658GCName.length > 0 || Object.hasOwn(submission.ratings[submission.type], 'u658ContractorName'))
            ) {
                Object.assign(
                    submission.ratings[submission.type],
                    { u658ContractorName: u658GCName }
                );
            }
            if (
                typeof u658GCName === 'string' &&
                (u658GCName.length > 0 || Object.hasOwn(submission.ratings.options, 'u658ContractorName'))
            ) {
                Object.assign(
                    submission.ratings.options,
                    { u658ContractorName: u658GCName }
                );
            }
            if (submission.isExcessOnly === true) {
                submission.isExcessOnly = false;
            }

            if (
                !isU653Applicable(
                    submission.coverages.gl && submission.coverages.gl.base ? submission.coverages.gl.base : '',
                    submission.type)
            ) {
                if (Object.hasOwn(submission.ratings[submission.type], 'u653Deductible')) {
                    delete submission.ratings[submission.type]['u653Deductible'];
                }
                if (Object.hasOwn(submission.ratings.options, 'u653Deductible')) {
                    delete submission.ratings.options['u653Deductible'];
                }
                if (Object.hasOwn(submission, 'optionalForms') && Object.hasOwn(submission.optionalForms, 'u653')) {
                    delete submission.optionalForms['u653'];
                }
            }

            if (submission.coverages?.gl?.base === 'deductibleWarranty' && submission.isDeductibleWarranty !== true) {
                submission.isDeductibleWarranty = true;
            }

            if (Object.hasOwn(submission, 'optionalForms') && Object.keys(submission.optionalForms).length === 0) {
                delete submission['optionalForms'];
            }

            const { failedReferralRules } = submission.ratings[submission.type];
            let result = '';
            let data = {};
            if (submission.clearanceStatus === 'pending') {
                result = 'submission_failed_clearance';
            } else if (failedReferralRules && failedReferralRules.length > 0 && submission.status !== 'DRAFT') {
                result = 'submission_failed_referral_rules_validation';
                submission.referralRules = failedReferralRules;
                data = failedReferralRules;
            } else if (submission.status === 'DRAFT') {
                result = 'submission_drafted';
                data = submission;
            } else {
                result = 'submission_saved';
                data = submission;
            }
            const response = {
                data,
                result,
                failedReferralRules
            };
            const actionData = {
                submission,
                payload: submission,
                quoteCount: this.props.quoteCount,
                result
            };
            if (submission.hasOwnProperty('ratings')) {
                this.props.dispatch(ratingsActions.update(submission.ratings));
            }
            this.props.handleSubmit(null, response);
            this.props.dispatch({
                type: CHANGE_SUBMISSION,
                payload: { submission }
            });
        }
    }

    render() {
        return (
            <form>
                <h3>Calculating Quote</h3>
                <p className="loading-copy">Please wait while we calculate.</p>

                <div className="loadingImg">
                    <LoadingSpinner width="200px" height="200px" />
                </div>

                <ButtonGroup>
                    <LinkContainer to="/submissions">
                        <Button className="btn"> Return to Submissions</Button>
                    </LinkContainer>
                </ButtonGroup>
            </form>
        );
    }
}

Loading.propTypes = {
    user: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    submission: PropTypes.object,
    quoteCount: PropTypes.number.isRequired,
    dispatch: PropTypes.func
};

const mapStateToProps = state => ({
    app: state.app,
    person: state.person,
    user: state.user
});

export default connect(mapStateToProps)(Loading);
